/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import axios from 'axios';

import './registerServiceWorker';
import App from './App.vue';
import router from './router';
import store from './store';
import {} from './plugins';
import { LightboxDirective } from './extensions/Lightbox.vue';

const eventHub = new Vue();
Vue.prototype.$eventHub = eventHub;

window.machineId = (new URLSearchParams(window.location.search)).get('machineId');

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.directive('lightbox', LightboxDirective);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
